import { render, staticRenderFns } from "./NotifyRemote.vue?vue&type=template&id=4fc32269&scoped=true&"
import script from "./NotifyRemote.vue?vue&type=script&lang=js&"
export * from "./NotifyRemote.vue?vue&type=script&lang=js&"
import style0 from "./NotifyRemote.vue?vue&type=style&index=0&id=4fc32269&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc32269",
  null
  
)

export default component.exports